/* Выбор из справочника */
(function ($) {
  var lastFocusedInputId = null;
  
  var rs = function (inp, o, img) {
    this.init(inp, o, img);
  };
  rs.prototype = {
    // HTML элементы.
    inp: null, // главный input
    container: null, // главный контейнерю
    results: null, // результаты поиска.
    table: null,
    img: null,
    title: null,
    footer: null,
    hidd: null,
    inpParent: null,
    selectedItems: null,
    selectedItemsCont: null,
    fakeInp: null,

    contId: '',

    // Таймауты.
    close: null, // на скрытие
    timeout: null, // на поиск
    spinner_timeout: null, // на спинер
    deleteItemsTimeout: null,

    // Настройка.
    url: null, // url for ajax request
    refcodes: {},
    refcodesCount: 0, //у объекта получить length нельзя.
    selectedRefCode: null,
    selectedRefIsClosed: false,
    extraParams: null,
    max: 25, // max result rows
    delay: 400, // for search
    minChars: 1,
    mustMatch: false,
    showNoMatchText: true,
    cellIDIndex: 0,
    cellToInput: 2,
    multiselect: false,
    referenceCodesAndReqNamesInDetailSection: null,
    allowlike: true,
    useadditional: true,
    isCustomSelect: false,
    selected: false,
    currentPage: 1,
    maxPages: 1,
    mainReferenceCode: '',
    dataProvider: null,
    sendQueryOnlyOnEnter: false,

    suggestInProcess: false,
    suggestLastMode: 'show',
    NoMatchText: L("NO_RECORDS_FOUND"),
    CancelText: L("CANCEL_ACTION"),
    SelectText: L("SELECT_X_FROM_Y_TEXT"),
    TitleText: L("CHOOSE_REFERENCE"),

    init: function (inp, options, img) {
      var self = $.extend(this, options);
      self.inp = $(inp);
      // Проверим проинициализирован ли контроль.
      if (self.inp.hasClass('rs_InitComplete')) return;
      if (self.isCustomSelect) self.inp.addClass('rs_custom');
      if (self.color) {
        self.inp.css('color', self.color);       
      }
      
      self.inp
        .addClass('rs_input')
        .data('selected', self.selected)
        .bind('focus.refselect', function () {
          // При фокусе скрываем все выпадающие списки записей всех реквизитов "Выбор из справочника".
          if (self.inp.attr('id') != lastFocusedInputId) {
            // Закрыть надо предыдущий, а не текущий.
            $('#' + lastFocusedInputId).HideContainer();
          };

          self.fakeInp.addClass('refselect-input_focused');
          self._hidePlaceholder();

          lastFocusedInputId = self.inp.attr('id');
        })
        .bind('blur.refselect', function () {
          // Если это инициализация значений или потеря фокуса, то сместим выбранные записи в самое лево, что бы был виден первый элемент.
          self.changeInpWidthAndPadding(true);
          self.fakeInp.removeClass('refselect-input_focused');
          if (!self.hidd.val() && !self.inp.val()) self._showPlaceholder();
        })
        .bind('SetSelected', function (e, v) {
          self.inp.data('selected', v);
          self.inp.trigger('onSelected');
          self._hidePlaceholder();
        })
        .bind('ReplaceSelectedItem', function (e, oldID, newValues, onlyLast) {
          self.replaceSelectedItem(oldID, newValues, onlyLast);
          self._hidePlaceholder();
        })
        .bind('Clear', function () {
          self.deleteAllItems();
          self._showPlaceholder();
        })
        .bind('HideContainer', function () {
          self.hideContainer();
        })
        .bind('SetValue', function (e, newValue, needTriggerResult) {
          self.setValue(newValue, needTriggerResult);
          self._hidePlaceholder();
        })
        .bind('SetValues', function (e, newValues, needTriggerResult) {
          self.setValues(newValues, needTriggerResult);
          self._hidePlaceholder();
        })
        .bind('SetDisabled', function (e, v) {
          if (!!v) {
            self.inp.attr('readonly', 'readonly').addClass('Req_Disabled').attr('tabindex', -1);
            self.inpParent.find('.fakeInput').addClass('Req_Disabled');
            self.selectedItems.find('span').addClass('Req_Disabled');
            if (self.img.length) {
              self.img.addClass('Req_Icon_Disabled');
            }
          } else {
            self.inp.removeAttr('readonly').removeClass("Req_Disabled").attr('tabindex', 0);
            self.inpParent.find('.fakeInput').removeClass("Req_Disabled");
            self.selectedItems.find('span').removeClass("Req_Disabled");
            if (self.img.length) {
              self.img.removeClass("Req_Icon_Disabled");
            }
          };

          // Событие изменения доступности
          self.inp.trigger('onAvailabilityChange', v);
        });

      self.inpParent = self.inp.parent();

      self.inp.bind('keydown', self, self.process);
      // хак для планшетов: создаем кнопку, навешиваем на нее клик, в клике ставим фокус на поле ввода
      // вызываем клик у кнопки при клике на див в котором находится поле ввода
      if ($.ipad || WA.ENV.isAndroid()) {
        if ($('#focusBtn' + self.inp.attr('id')).length === 0) {
          var btn = $('<input type="button" style="display:none;" id="focusBtn' + self.inp.attr('id') + '" />')
            .unbind('click')
            .click(function () {
              self.inp.focus();
            });

          $('body').append(btn);
        } else {
          $('#focusBtn' + self.inp.attr('id')).unbind('click').click(function () {
            self.inp.focus();
          });
        }

        self.inp.parent().click(function () {
          $('#focusBtn' + self.inp.attr('id')).click();
        });
      }


      if (self.allowlike) {
        if ($.ipad && WA.ENV.isAndroid()) {
          self.oldv = self.inp.val();
          var pollTimer = null;
          var interval = 500;
          function pollInputChanged() {
            if (!self.inp.is(':focus')) return;

            try {
              self.onInputChanged(self.sendQueryOnlyOnEnter);
              self.changeInpWidthAndPadding();
              pollTimer = setTimeout(pollInputChanged, interval);
            } catch (_) { }
          }
          self.inp.bind('focus', function () {
            pollTimer = setTimeout(pollInputChanged, interval);
          }).bind('blur', function () {
            if (pollTimer) clearTimeout(pollTimer);
            //self.inp.val(''); закомментил тк при при смене справочника в выпадающем списке не подгружались записи по фильтру
          });
        };
      } else {
        self.inp.bind('change', function () {
          // Передаем значение введенное пользователем со знаком $, что бы отличить от выбранного из справочника.
          self.hidd.val('$' + $(this).val());
        });
      };

      if (img != null) {
        self.img = $(img)
          .addClass('rs_img')
          .bind('click touchstart', function (ev) {
            // Помечаем выделенным при нажатии на "...", что бы он не закрывался раньше времени (на событии onFocus, когда lastFocusedInputId = null).
            lastFocusedInputId = self.inp.attr('id');
            return self.onImgClick(ev);
          });
      }

      // Скрытие вариантов при click на любое другое место.
      $('html').bind('click.refselect', function (ev) {
        var t = $(ev.target);
        if (t && t.length > 0) {
          var className = t[0].className;
          if (className && className.baseVal) {
            className = className.baseVal;
          }
          if (typeof className === 'string' && className.indexOf('rs_') === -1 && className.indexOf('-icon') === -1) {
            if (self.table.find("tr").length === 1 && self.inp.val() !== "") {
              self.select(true);
            }
            if (self.container.is(':visible')) self.hideContainer();
          }
        } else {
          if (self.container.is(':visible')) self.hideContainer();
        }
      });

      self.contId = 'rscont' + (Math.random() * 100 | 0);
      self.container = $('<div class="rs_container refselect-input__results stat_RerefenceRequisiteResults" id="' + self.contId + '"></div>').appendTo("body");
      self.results = $('<div class="rs_results"><div id="loller"></div></div>').appendTo(self.container);
      self.title = $('<div></div>').prependTo(self.container);
      self.table = $('<table class="rs_table" cellpadding="2" cellspacing="0"></table>').appendTo(self.results.find('#loller'));
      self.footer = $('<div></div>').appendTo(self.container);

      if (self.multiselect) {
        self.table.addClass('rs_multiselect_table');
      }

      // Контейнер что бы выбранные элементы не налезали на "...".
      self.selectedItemsCont = $('<div class="rs_SelItems_cont"></div>');
      self.selectedItems = $('<div class="rs_SelItems"></div>');

      self.selectedItemsCont.bind('click.refselect', function () {
        // Перемещаем input в конец.
        self.selectedItems.children('span:last').after(self.inp);
        self.changeInpWidthAndPadding();
        setTimeout(function () { //для IE
          self.inp.focus();
        }, 100);
      });
      if (inp.hasClass('Req_Disabled')) {
        self.inp.SetDisabled();
      }

      self.selectedItemsCont.append(self.selectedItems);
      self.inpParent.prepend(self.selectedItemsCont);

      self.moveInputToSelecetedItem();

      self.initSelecetedItems();

      if (self.hidd.val()) self._hidePlaceholder();

      // Инициализация закончена.
      self.inp.addClass('rs_InitComplete');
      // Подобрать ширину для значения реквизита
      $(function () { self.changeInpWidthAndPadding(); });
    },

    onImgClick: function (ev) {
      var self = this;
      ev.preventDefault();
      ev.stopPropagation();
      if (!self.inp.attr('readonly') && !self.inp.attr('disabled')) {
        self.container.hide();
        self.table.empty().removeData('refcode');
        self.currentPage = 1;
        self.clearBlurTimeout();
        self.suggestLastMode = 'show_all';
        self.suggest(function () {
          self.results.scrollTop(0);
        });
      }
    },

    isReadonly: function () {
      var self = this;
      return (self.inp.attr('readonly'));
    },

    initSelecetedItems: function (_ids, _names) {
      var self = this;

      var hiddVals = self.hidd.val();
      var inpVals = self.inp.val();

      var ids = _ids || (hiddVals ? hiddVals.split(';') : []);
      var names = _names || (inpVals ? inpVals.split(';') : []);

      var html = '';
      for (var i = 0; i < names.length; i++) {
        var val = [];
        val[self.cellIDIndex] = $.trim(ids[i]);
        val[self.cellToInput] = $.trim(names[i]);
        if (val[self.cellIDIndex] != '') {
          html += self.createNewSelecetedItemHTML(val);
        }
      }
      //TODO Шамов А.: Когда-нибудь переделать на setValues.
      self.createNewSelecetedItem(null, $(html));

      // Если это инициализация значений или потеря фокуса, то сместим выбранные записи в самое лево, что бы был виден первый элемент.
      setTimeout(function () { // CardForm инициализирует значения немного позже, поэтому для него setTimeout.
        self.changeInpWidthAndPadding(true);
      }, 150);

      //Навешиваем событие на resize окна, что бы изменялось положение выбранных записей.
      if (!self.multi_windowResizeInit) {
        var rsTimeout;
        $(window).bind('resize.refselect', function () {
          if (rsTimeout) clearTimeout(rsTimeout); // нужен что бы часто не рассчитывать.
          rsTimeout = setTimeout(function () {
            self.changeInpWidthAndPadding();
          }, 100);
        });
        self.multi_windowResizeInit = true;
      }
    },

    // Загрузка нужной страницы.
    loadPage: function (delta) {
      var self = this;
      var p = self.currentPage;
      if (delta == -2) {
        p = 1;
      } else if (delta == -1) {
        p -= 1;
      } else if (delta == 1) {
        p += 1;
      } else if (delta == 2) {
        p = self.maxPages;
      }

      if (p < 1) p = 1;
      if (p > self.maxPages) p = self.maxPages;

      if (self.currentPage != p) {
        self.currentPage = p;
        self.suggest();
      }
    },

    // Удаление таймаута на событии onblur главного inputa.
    clearBlurTimeout: function () {
      var self = this;
      clearTimeout(self.close);
      self.inp.focus();
    },

    onInputChanged: function (disableSendQuery) {
      var self = this;
      setTimeout(function () { //эта функция вызывается в keypress и что бы в input появился символ, который нажали, делаем этот setTimeout.
        var v = $.trim(self.inp.val());
        if (v !== self.oldv) {
          // Сохраняем предыдущее значение только если будем отправлять запрос.
          if (!disableSendQuery) {
            self.oldv = v;
          }
          var check = v;
          check = check.replace(/ /g, "");
          var len = check.length;
          if (len >= self.minChars) {
            if (self.timeout) clearTimeout(self.timeout);
            self.timeout = setTimeout(function () {
              // Если быстро ввести  и удалить символ отображалась выпадайка со всеми записями,
              // но терялся констекст и она была в верхнем левом углу, поэтому если в инпуте ничего не введено выпадайку не показываем.
              if (self.oldv.length > 0) {
                self.suggestLastMode = 'show';
                self.suggest(function () {
                  self.results.scrollTop(0);
                }, disableSendQuery);
              };
            }, self.delay);
          } else {
            if (v == '' && !self.multiselect) {
              self.selectEmpty(true);
            }
            self.hideContainer();
          };
        };
      }, 100);
    },

    // Перемещение по справочникам.
    moveReference: function (d) {
      var self = this;
      var refCaptions = $.merge(self.title.children(), self.footer.children());
      var selected = refCaptions.filter('.selected');
      if (d == 0) {
        return selected;
      } else {
        var nextSelIndex = refCaptions.index(selected.removeClass('selected').get(0)) + d;
        if (nextSelIndex == -1) {
          nextSelIndex = refCaptions.length - 1;
        }
        if (nextSelIndex == refCaptions.length) {
          nextSelIndex = 0;
        }
        return $(refCaptions.get(nextSelIndex)).addClass('selected');
      }
    },

    // Обработка нажатий на клавищи.
    process: function (e) {
      var self = e.data;

      if (self.inp.attr('readonly') || self.inp.attr('disabled')) return;

      if (!(/^13$|^9$/.test(e.keyCode)) && !self.container.is(':visible')) {
        self.inp.data('selected', 'false'); // Значение изменилось.
      }

      //alt+down для раскрытия полного списка.
      if (e.altKey && e.keyCode == 40 && $.trim(self.inp.val()) == '' && !self.container.is(':visible')) {
        self.onImgClick(e);
      }


      // Влево/вправо при множественном выборе
      if (self.multiselect && /^46$|^36$|^35$|^37$|^39$/.test(e.keyCode) && $.trim(self.inp.val()) == '') {
        e.preventDefault();
        e.stopPropagation();
        switch (e.keyCode) {
          case 46: //del
            //Если пользователь удаляет много элементов подрят, то удалим все элементы сразу.
            if (!self.checkLongDeletion()) {              
              self.deleteItems(self.inp.next());
            } else {
              self.deleteAllItems();
            };
            break;
          case 36: //home
            self.multiLeft(true);
            break;
          case 35: //end
            self.multiRight(true);
            break;
          case 37: //left
            // Выпадающиего списка нет, то переходим между элементами.
            if (!self.container.is(':visible')) {
              self.multiLeft();
            }
            break;
          case 39: //right
            if (!self.container.is(':visible')) {
              self.multiRight();
            }
            break;
        };
      };

      // Скрытие/раскрытие записей справочника.
      if (self.refcodesCount > 1 && /^37$|^39$/.test(e.keyCode) && self.container.is(':visible')) {
        e.preventDefault();
        e.stopPropagation();
        //left, right
        if (e.keyCode == 37 || e.keyCode == 39) {
          self.selectReference(self.moveReference(0));
        }
      }

      // Backspace работает всегда
      if (/^8$/.test(e.keyCode) && self.inp.val() == '') {
        e.preventDefault();
        e.stopPropagation();
        //Если пользователь удаляет много элементов подрят, то удалим все элементы сразу.
        if (!self.checkLongDeletion()) {          
          self.deleteItems(self.inp.prev());
        } else {
          self.deleteAllItems();
        };
      }

      if ((/^27$|^38$|^40$/.test(e.keyCode) && (self.container.is(':visible') || self.suggestInProcess)) || (/^13$|^9$/.test(e.keyCode) && self.container.is(':visible') && self.get())) {
        e.preventDefault();
        e.stopPropagation();
        switch (e.keyCode) {
          case 38: //up
            if (self.table.is(':visible')) {
              self.prev();
            } else {
              // Таблица с записями скрыта, значит выбираем справочник.
              self.moveReference(-1);
            }
            break;
          case 40: //down
            if (self.table.is(':visible')) {
              self.next();
            } else {
              // Таблица с записями скрыта, значит выбираем справочник.
              self.moveReference(1);
            }
            break;
          case 9:  //tab
          case 13: //return
            if (self.table.is(':visible')) {
              // Выбор записи справочника.
              var selected_row = self.get();
              if (selected_row != null) {
                selected_row.click();
              } else {
                self.select();
              }
            } else {
              // Выбор справочника.
              self.selectReference(self.moveReference(0));
            }
            break;
          case 27: // escape
            self.hideContainer();
            break;
        }
      } else {
        if (e.keyCode !== 9 && self.allowlike) {

          //Если включен режим поиска только при нажатии на Enter, то проверяем кнопку.
          var disableSendQuery = false;
          if (self.sendQueryOnlyOnEnter) {

            // Если продолжили набирать, то скрываем предыдущие результаты.
            self._hideAndResetContainer();

            if (e.keyCode === 13) {
              e.preventDefault();
              e.stopPropagation();
              disableSendQuery = false;
            } else {
              disableSendQuery = true;
            }
          }

          self.onInputChanged(disableSendQuery);
        }
      }
    },

    // Проверяет долгое нажатие на кнопку Del/Backspace.
    checkLongDeletion: function () {
      var self = this;

      // Запомним время первого нажатия кнопки удалить (Del/Backspace).
      if (self._startDeleteTime === null) {
        self._startDeleteTime = $.now();
      };

      //Если прошло 1.5 с. с момента первого нажатия, то это долгое нажатие кнопки удалить.
      if (($.now() - self._startDeleteTime) > 1500) {
        return true;
      };

      // Таймер для сброса времени первого нажатия кнопки удалить.
      if (self._deleteTimeout) clearTimeout(self._deleteTimeout);
      self._deleteTimeout = setTimeout(function () {
        self._startDeleteTime = null;
      }, 300);

      //Не должгое нажатие.
      return false;
    },
    _startDeleteTime: null,
    _deleteTimeout: null,


    // Получение текущей выделенной строки таблицы.
    get: function () {
      var self = this;
      return self.table.find('.rs_tr_over');
    },

    // Переход на предыдущую строку
    prev: function () {
      this.move(-1);
    },

    // Переход на следующую строку
    next: function () {
      this.move(1);
    },

    move: function (delta) {
      var self = this;
      var current = self.get();
      var next = (delta > 0 ? current.next() : current.prev());
      var overed;
      if (current.length > 0) {
        if (next.length > 0) {
          current.parent().find('.rs_tr_over').removeClass('rs_tr_over');
          overed = next.addClass('rs_tr_over');
        }
      } else {
        overed = self.table.find('tr:first').addClass('rs_tr_over');
      }
      self.scrollToOver(overed);
    },

    scrollToOver: function (overed) {
      var self = this;
      if (overed && overed.length > 0) {
        var overTop = overed.position().top;
        if ((overTop + overed.height()) > self.results.height()) {
          self.results.scrollTop(self.results.scrollTop() + overTop - overed.height());
        }
        if (overTop < 0) {
          self.results.scrollTop(self.results.scrollTop() + overTop + overed.height() - self.results.height());
        }
      }
    },

    //Получаем все выбранные записи.
    getValues: function () {
      var self = this;
      var v = [];
      if (self.selectedItems !== null) {
        self.selectedItems.children('span').each(function () {
          var item = $(this);
          var refcode;
          var id = '' + item.data('id');
          var idParts = id.split(':');
          if (idParts.length == 2) {
            refcode = idParts[0];
            id = idParts[1];
          } else {
            refcode = self.getFirstRefCode();
          };
          v.push({
            groupcode: refcode,
            id: id,
            name: '' + item.data('text')
          });
        });
      }
      return v;
    },

    // Устанавливает 1 значение.
    setValue: function (newValue, needTriggerResult) {
      var self = this;
      var oldHiddVal = self.hidd.val();

      // Если не множественный выбор, то очищаем предыдущее значение.
      try {
        if (!self.multiselect) {
          self.deleteAllItems(false);
        }
      } catch (e) {
        console.log(e);
      }

      if (newValue != null) {
        // Создаем новый выбранный элемент.
        self.createNewSelecetedItem(newValue);
      }

      if (!!needTriggerResult) {
        if (self.allowlike) {
          self.triggerResultEvent(oldHiddVal, newValue);
        } else {
          self.inp.trigger('changeOnSelectValue', [newValue]);
        }
      }

      self.inp.data('selected', '' + (newValue != null));
    },

    // Устанавливает множество значений. Формат [{groupcode:'код справочника', id:'ид записи', name:'наименование'}, ...]
    setValues: function (newValues, needTriggerResult) {
      var self = this;
      if (self.multiselect) {
        var oldHiddVal = self.hidd.val();

        self.deleteAllItems(false);

        var html = '';
        for (var i = 0; i < newValues.length; i++) {
          var val = [];
          val[self.cellIDIndex] = $.trim(newValues[i].groupcode + ':' + newValues[i].id);
          val[self.cellToInput] = $.trim(newValues[i].name);
          if (val[self.cellIDIndex] != '') {
            //Для увеличения скорости работы не вызываем setValue.
            html += self.createNewSelecetedItemHTML(val);
          }
        }
        self.createNewSelecetedItem(null, $(html));
        if (!!needTriggerResult) {
          self.triggerResultEvent(oldHiddVal, newValues);
        }

        self.inp.data('selected', '' + (html != ''));
      }
    },

    triggerResultEvent: function (oldHiddVal, val) {
      var self = this;
      if (self.hidd.val() != oldHiddVal) {
        if (self.multiselect) {
          //Шамов А.: Не вызываем триггер result во множественном выборе, т.к. оно перезапишет значение в скрытом поле.
          self.inp.trigger("resultMulti", [val, self.getValues()]);
        } else {
          self.inp.trigger("result", [val]);
        }
      }
    },

    // Значение выбранно.
    select: function (isOne, el) {
      var self = this;
      var selected_row = el ? el : (isOne ? self.table.find('tr') : self.table.find('.rs_tr_over'));
      if (selected_row != null) {
        var data = selected_row.data('rowData') || null;
        if (data !== null) {
          var val = [data.id, data.encodedTitle, data.title, data.leadingRequisitesValue];
          self.inp.val(val[self.cellToInput]);
          val[0] = (self.isCustomSelect || self.refcodesCount > 1 || self.multiselect ? (self.selectedRefCode + ':') : '') + val[0]; //добавляем код выбранного справочника.

          self.setValue(val, true);

          // Если оставить этот setTimeout то в детальных раздела прохо работает клавиатурная навигация.
          if (WA.ENV.browser.name === 'IE' && self.inp.parents('.slick-cell').length === 0) {
            // Для IE иначе после выбора нельзя ничего написать (#103690).
            setTimeout(function () {
              self.inp.blur();
              self.inp.focus();
            }, 100);
          }
          self.hideContainer();
        }
      }
    },

    // Перемещает реальный input в div с выбранными.
    moveInputToSelecetedItem: function () {
      var self = this;

      // Shirobokov_AV: Для исправления дефекта с неотображаемыми текстбоксами в хроме и сафари (№ 56018).
      if ($('#modal_window form').length != 0) { $('#modal_window form').css("position", "relative"); }

      if (self.selectedItems.find('input').length == 0) {
        // Создаем фэйковую input для сохранения красоты.
        var placeholder = self.inp.data('placeholder') ? self.inp.data('placeholder') : self.inp.attr('placeholder');
        self.fakeInp = $('<input class="fakeInput" tabIndex="-1">')
          .bind('focus.refselect', function () {
            self.inp.focus();
          })
          .addClass(self.inp.attr('class'))
          .attr('placeholder', placeholder);

        if (self.backgroundColor) {
          self.fakeInp.css('background-color', self.backgroundColor);
        }

        if ($.ipad) {
          self.inpParent.bind('click touchstart', function (e) {
            self.inp.focus();
            if (!WA.ENV.isAndroid()) {
              e.stopPropagation();
            }
          });
        }

        self.inpParent.append(self.fakeInp);
        self.inpParent.attr('data-stataction', 'Requisite');

        self.fakeInp.on('contextmenu', function (e) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        });

        // Корректируем стили для множественного выбора.
        /*self.inpParent.css({ 'padding-right': '2px' });
        self.img.css({ right: 0 });*/

        // Добавляем реальный input в div с выбранными.
        self.selectedItems.append(self.inp);

        self.inp
          .addClass('rs_multi_input')
          .bind('keyup.refselect', function () {
            self.changeInpWidthAndPadding();
          })
          .bind('click.refselect', function (e) {
            // Запрещаем все остальные события, такие как клик на контейнер выбранных записей.
            e.stopPropagation();
          });
      }
    },

    // Формирует HTML строку для выбранного элемента.
    createNewSelecetedItemHTML: function (val) {

      var self = this;

      if (val[self.cellToInput] == '') return '';

      // Передано выбранное значение с кодом справочника, то вычленим его.
      var refCode = '';
      var id = val[self.cellIDIndex];
      var idParts = ('' + id).split(':');
      // Получаем код справочника из ИД, если он там есть, иначе берем переданный или первый в списке.
      if (idParts.length == 2) {
        refCode = idParts[0];
        id = idParts[1];
      } else {
        refCode = self.getFirstRefCode();
      }

      var refDesc = null;
      if (refCode != '' && typeof self.refcodes[refCode] !== 'undefined') {
        refDesc = self.refcodes[refCode];
      }

      var hintData = self.getHintData(refCode, id, val[self.cellToInput]);
      var delIco = $.ipad && !self.isReadonly() ? '<svg class="refselect-input__clear-icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#close-delete-16"></use></svg>' : (self.multiselect ? ';' : '');      
      var inputText = (val[self.cellToInput] === 'undefined') ? '' : ('' + val[self.cellToInput]).escapeHtml();
      var dataText = ' data-text="' + inputText + '" ';

      // Если нет прав на реквизит, то не подчеркиваем *.
      var spanClass = '';
      if (val[self.cellToInput] == '*') {
        delIco = '';
        spanClass = ' underline-none ';
      }
      let dataId = val[self.cellIDIndex].toString().escapeHtml();
      let spanAttributes = `class="${hintData['class']}${spanClass}" data-id="${dataId}" ${dataText} ${hintData['attr']}`;
      if (self.inp.css('color')) {
        spanAttributes += ` style="color:${self.inp.css('color')}"`;
      }
      return `<span ${spanAttributes }><b>${inputText}</b>${delIco}</span>`;
    },

    // Создает новый выбранный элемент.
    createNewSelecetedItem: function (val, items) {
      var self = this;
      var lastItem;

      if (typeof items === 'undefined' || items == null) {
        var html = self.createNewSelecetedItemHTML(val);
        if (html == '') return;
        lastItem = $(html);
      } else {
        lastItem = items;
      }

      if (self.isReadonly()) {
        lastItem.addClass('Req_Disabled');
      } else {
        lastItem.bind('click.refselect', function (e) {
          if (self.multiselect) {
            // Запрещаем все остальные события, такие как клик на контейнер выбранных записей.
            e.stopPropagation();
            var $this = $(this);
            var middleX = $this.offset().left + ($this.outerWidth(true) / 2);
            // Если кликнули на первую половину, то input перемещаем слева, иначе справа.
            if (e.clientX < middleX) {
              $this.before(self.inp);
            } else {
              $this.after(self.inp);
            }
            self.changeInpWidthAndPadding();
          }
          setTimeout(function () { //для IE
            self.inp.focus();
          }, 100);
        });
        lastItem.find('svg').one('click.refselect touchstart', function () { self.deleteOneItem($(this).parent()); });
      }

      self.inp.before(lastItem);

      // Подсказки к выбранным элементам.
      $.each(lastItem, function () {
        if ($(this).hasClass('hint')) {
          InitAdditionalInfoTooltip($(this));
        }
      });

      // Очищаем input, т.к. уже добавили новый элемент во внешнюю div.
      self.inp.val('');
      self.oldv = '';

      // Обновляем скрытое поле.
      self.changeHiddenValue();

      //Изменяем ширину input.
      self.changeInpWidthAndPadding();
    },

    // Удаляет переданный элемент.
    deleteOneItem: function (item, callSelectEmpty, isNeedAnimate) {
      var self = this;
      if (item.length > 0) {
        var removeFunc = function () {
          $(item).remove();
          var oldval = self.hidd.val()

          self.changeHiddenValue();

          self.triggerResultEvent(oldval, null);

          self.changeInpWidthAndPadding();
          //Вызываем функцию здесь, чтобы сработала после анимации, для множественного выбора один раз должна сработать
          if (self.selectedItems.children('span').length == 0) {
            self.selectEmpty(callSelectEmpty !== false);
          }
        };
        if (isNeedAnimate !== false) {
          item.animate({ width: 0 }, 300, 'linear', removeFunc);
        } else {
          removeFunc();
        }
      }
    },

    /**
    * Удаляет элементы пачкой по таймауту.
    *
    * @method deleteItems
    * @param {Object} item Удаляемый элемент.
    * @private    
    * @since 5.7.0
    */    
    deleteItems(item) {      
      if (item.length) {
        const oldval = this.hidd.val();
        const removeFunc = () => {
          // Ожидаем удаления следующий элементов в течении 0,5 с, чтобы отправить один запрос на сервер.
          clearTimeout(this.deleteItemsTimeout);
          this.deleteItemsTimeout = setTimeout(() => {
            this.changeHiddenValue();
            this.triggerResultEvent(oldval, null);
          }, 500);    
                    
        };
        removeFunc();
        item.animate({ width: 0 }, 300, 'linear', () => {
          $(item).remove();
          this.changeInpWidthAndPadding();
        });                  
      }        
    },

    // Удаляет все элементы.
    deleteAllItems: function (callSelectEmpty) {
      var self = this;
      if (self.selectedItems !== null) {
        var childspan = self.selectedItems.children('span');
        if (childspan.length > 0) {
          self.selectEmpty(callSelectEmpty !== false);
        }
        childspan.remove();
      }
      self.changeHiddenValue();
      self.changeInpWidthAndPadding();
    },

    // Изменяет ширину input и сдвигает каретку.
    changeInpWidthAndPadding: function (isInitOrBlur) {
      var self = this;

      if (self.inpParent !== null) {
        // Если inpParent скрыт, то Width работать не будет, поэтому навешиваемся на любой клик для мониторинга видимости этого элемента.
        if (self.inpParent.is(':hidden')) {
          var checkVis = function () {
            if (self.inpParent.is(':visible')) {
              self.changeInpWidthAndPadding();
              $('body').unbind('click keyup keydown', checkVis);
            }
          }
          $('body').bind('click keyup keydown', checkVis);
          return;
        }

        var parentWidth = self.inpParent.width() - 21; //21 - картинка с "..."
        self.selectedItemsCont.css({ 'width': parentWidth });
      }


      // Меняем длину input в зависимости от введенного текста.
      var inpWidth = 12;
      if ($.ipad) {
        inpWidth = 70;
      }
      self.inp.css({ 'width': (inpWidth + self.getTextMetric(self.inp)) });

      // Считаем длину всех выбранных элементов для сдвига.
      var sumWidthBeforeInp = 0;
      var sumWidthAll = 0;
      var isInp = false;
      if (self.selectedItems !== null) {
        self.selectedItems.children().each(function () {
          var w = $(this).outerWidth(true);
          sumWidthAll += w;
          // Считаем сумму выбранных элементов до input + сам input, что бы input находился всегда на виду.
          if (!isInp) {
            sumWidthBeforeInp += w;
            isInp = $(this).hasClass('rs_multi_input');
          }
        });
      }
      // Сдвигам влево выбранные записи.
      var dLeft = parentWidth - sumWidthBeforeInp;
      // Если это инициализация значений или потеря фокуса, то сместим выбранные записи в самое лево, что бы был виден первый элемент.
      if (dLeft < 0 || dLeft > 0 || !!isInitOrBlur || !self.inp.is(':focus')) dLeft = '0px'; //что бы не уезжал вправо
      if (self.selectedItems !== null) {
        self.selectedItems.css({ left: dLeft });
        self.selectedItemsCont.scrollLeft(0); //При focus'е на input невидимый (overflow:hidden) скрол смещается, ставим его наместо!
      }
      self.setCoordForContainer();
    },

    // Определяет ширину введенного текста в input.
    getTextMetric: function (input) {
      var body = $('body');
      var textMetric = body.find('.textMetric:first');
      if (textMetric.length == 0) {
        textMetric = $('<div>').addClass('textMetric').css({
          position: 'absolute',
          left: -1000,
          top: -1000,
          display: 'none'
        });
        body.append(textMetric);

        var styles = ['font-size', 'font-style', 'font-weight', 'font-family', 'line-height', 'text-transform', 'letter-spacing'];
        $.each(styles, function () {
          var s = this.toString();
          textMetric.css(s, input.css(s));
        });
      }
      let text = '';
      if (input.val()) {
        text = input.val().replace(/ /g, '&nbsp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      }
      return textMetric.html(text).outerWidth();
    },

    // Обновляет скрытое поле значениями из выбранных блоков.
    changeHiddenValue: function () {
      var self = this;
      var ids = '';
      if (self.selectedItems !== null) {
        self.selectedItems.children('span').each(function () {
          ids += $(this).data('id') + ';';
        });
      }
      // Удаляем последнюю ;
      if (ids != '') {
        ids = ids.substr(0, ids.length - 1);
        self._hidePlaceholder();
      }

      self.hidd.val(ids);
    },

    // Заменяет выбранный элемент на новые.
    replaceSelectedItem: function (oldID, newValues, onlyLast) {
      var onlyLast = onlyLast || false;
      var self = this;

      var replaced = self.selectedItems.find('span[data-id="' + oldID + '"]');
      if (onlyLast) {
        replaced = replaced.last();
      };

      if (replaced.length > 0) {
        replaced.after(self.inp);
        self.deleteOneItem(replaced, true, false);

        var html = '';
        $.each(newValues, function () {
          html += self.createNewSelecetedItemHTML(this);
        });

        // Создаем сразу все span так быстрее.
        self.createNewSelecetedItem(null, $(html));

        setTimeout(function () {
          self.inp.focus();
        }, 100);
      }
    },

    // Событие при нажатии клавиши влево при множественном выборе.
    multiLeft: function (toBegin) {
      var self = this;
      var item;
      if (toBegin) {
        item = self.selectedItems.children('span:first');
      } else {
        item = self.inp.prev();
      }
      item.before(self.inp);

      setTimeout(function () { //для IE
        self.inp.focus();
      }, 100);

      self.changeInpWidthAndPadding();
    },

    // Событие при нажатии клавиши вправо при множественном выборе.
    multiRight: function (toEnd) {
      var self = this;
      var item;
      if (toEnd) {
        item = self.selectedItems.children('span:last');
      } else {
        item = self.inp.next();
      }
      item.after(self.inp);

      setTimeout(function () { //для IE
        self.inp.focus();
      }, 100);

      self.changeInpWidthAndPadding();
    },

    // Значение из представленных не выбранно.
    selectEmpty: function (AlwaysEmpty) {
      var self = this;
      if (self.mustMatch || AlwaysEmpty) {
        self.inp.val('');
        //Шамов А.: Убрал, т.к. удалять если в Input ввели что-то некорректно не правильно, пусть остается предыдущее значение.
        //self.deleteAllItems();
        //self.inp.trigger('result', [null]);
        var item = self.selectedItems.find('span');
        if (item.length == 1) {
          //Значение осталось прежним выбранным.
          self.inp.data('selected', true);
        } else {
          //Ничего ранее выбранно не было и сейчас не выбрали, то сообщаем об этом внешнему интерфейсу.
          if (self.multiselect) {
            //Шамов А.: Не вызываем триггер result во множественном выборе, т.к. оно перезапишет значение в скрытом поле.
            self.inp.trigger("resultMulti", [null]);
          }
          else {
            self.inp.trigger('result', [null]);
          }
        }
      }
    },

    // Отображает выбор из справочника.
    showContainer: function () {
      var self = this;
      $.each($('.rs_container'), function () {
        if ($(this).attr('id') != self.contId) $(this).hide();
      });

      // Не отображаем выпадающий список, если открылся модальный диалог и этот выбор из справочника не в нем.
      if ($('.ui-dialog:visible').length == 0 || self.img.parents('.ui-dialog').length > 0) {
        self.setCoordForContainer();
        self.container.show();
        var firstItem = self.table.find('tr:first');
        if (firstItem.data('rowData') && self.table.find('tr.rs_tr_over').length == 0) firstItem.addClass('rs_tr_over');
        if ($.scrollActive) {
          if (!self.container.data('iscroll')) {
            self.container.data('iscroll', new iScroll(self.container.find('.rs_results')[0]));
          } else {
            self.container.data('iscroll').refresh();
          }
        }
      };

      self.bindScrollLoad();
    },

    bindScrollLoad: function () {
      var self = this;
      self.results.off('scroll.refselect').on('scroll.refselect', function () {
        var scroller = $(this);
        var table = scroller.find('table:first');
        var bottomDistance;
        if (!self.suggestInProcess) {
          if ($.scrollActive) { // проверка на скролл на сенсорных устройствах
            bottomDistance = table.height() - scroller.height() - scroller.offset().top + table.offset().top;
          } else {
            bottomDistance = table.height() - (scroller.scrollTop() + scroller.height());
          }
          if (bottomDistance < 100) self.loadPage(1);
        }
      });
    },

    // Скрывает выбор из справочника и очищает поле ввода если ничего не выбрано.
    hideContainer: function () {
      var self = this;
      if (self.inp.data('selected') == 'false') {
        self.selectEmpty(true);
      }
      self._hideAndResetContainer();
    },

    // Скрывает выбор из справочника.
    _hideAndResetContainer: function () {
      var self = this;
      self.selectedRefCode = null;
      self.selectedRefIsClosed = false;
      self.results.off('scroll.refselect');
      self.table.empty().removeData('refcode');
      self.currentPage = 1;
      self.oldv = '';
      $('.rs_container').hide();
    },

    getQueryValue: function () {
      var self = this;
      var v = self.inp.val();
      if (self.multiselect) {
        var vs = v.split(';');
        v = vs[vs.length - 1];
      }
      return $.trim(v);
    },

    showSpinner: function () {
      var self = this;
      if (self.spinner_timeout != null) clearTimeout(self.spinner_timeout);
      self.spinner_timeout = setTimeout(function () {
        var spinner = self.img.find('.refselect-input__spinner');
        var icon = self.img.find('.refselect-input__icon');
        if (spinner.length === 0) {
          self.img.append('<div class="circle-spinner refselect-input__spinner"></div>');
        } else {
          spinner.show();
        }
        icon.hide();
      }, 100);

      self.suggestInProcess = true;
      self.inp.addClass('suggestInProcess');
    },

    hideSpinner: function () {
      var self = this;
      if (self.spinner_timeout != null) clearTimeout(self.spinner_timeout);
      if (self.img !== null) {
        var spinner = self.img.find('.refselect-input__spinner');
        var icon = self.img.find('.refselect-input__icon');

        if (spinner) {
          spinner.hide();
          icon.show();
        }
      }
      self.suggestInProcess = false;
      self.inp.removeClass('suggestInProcess');
    },

    // Получает первый переданный справочник.
    getFirstRefCode: function () {
      var self = this;
      // Получить первый элемент можно только так.
      for (var refcode in self.refcodes) {
        // Возвращаем первый реальный справочника, а не псевдо (#95748).
        if (!self.refcodes[refcode].IsPseudoReference) {
          return refcode;
        }
      }
      return '';
    },

    /**
    * Установить выборку из указанных справочников
    * @param {object} references - информация о справочниках {"ОРГ":{"Caption":
    * "организации",...},"РАБ":{..}}}
    * @function setReferences
    */
    setReferences: function (references) {
      this._checkIsReferencesSetProperly(references);
      this.refcodes = references;
      this.refcodesCount = this._getReferencesCount();
      this._makeIconAccessible();
      return this;
    },

    /**
    * К существующим спраочникам, по которым идет выборка, добавить указанные.
    * @param {object} references - информация о справочниках {"ОРГ":{"Caption":
    * "организации",...},"РАБ":{..}}}
    * @function addReferences
    */
    addReferences: function (references) {
      this._checkIsReferencesSetProperly(references);
      var object = $.extend(this.refcodes, references);
      this.refcodesCount = this._getReferencesCount();
      this._makeIconAccessible();
      return this;
    },

    /**
    * Проверка введенных параметров
    * @private
    */
    _checkIsReferencesSetProperly: function (references) {
      if (!references) WA.raise("ERR_NOT_ALL_REQUIRED_ARGUMENTS_HAVE_BEEN_SUPLIED", "references");
      if (typeof references !== 'object') {
        WA.raise('ERR_AN_INVALID_PARAMETER_WAS_PASSED_TO_FUNCTION');
      };
    },

    /**
    * Сделать иконку кликабельной, и задать ей нормальную подпись.
    * @private
    */
    _makeIconAccessible: function () {
      this.img.removeClass("Req_Icon_AccessDenied");
      this.img.attr("title", this._getToolTip());
    },

    /**
    * Сформировать текст сплывающей подсказки.
    * @private
    */
    _getToolTip: function () {
      var lbl = "RECORDS_OF_REFERENCE";
      if (this.refcodesCount > 1) lbl = "RECORDS_OF_REFERENCES";
      var refs = [];
      for (var item in this.refcodes) {
        refs.push(this.refcodes[item].Caption);
      };
      return L(lbl, '"' + refs.join(", ") + '"');
    },

    /**
    * Подсчет кол-ва справочников по которым идет выборка.
    * @private
    */
    _getReferencesCount: function () {
      var count = 0;
      for (var k in this.refcodes) {
        if (this.refcodes.hasOwnProperty(k)) {
          ++count;
        }
      }
      return count;
    },

    // Список последних запросов к серверу.
    lastRequests: [],
    // Выполняет поисковый запрос.
    suggest: function (afterShowCallback, disableSendQuery) {
      var self = this;

      // Блокируем поиск если это необходимо.
      if (!!disableSendQuery) return;


      function onSearchQueryDoneCallback() {
        var refCode;
        if (self.refsWithRecords.length == 0) {
          refCode = self.getFirstRefCode();
        } else {
          //Найдено больше 2 справочников, покажем выбор из первого справочников с записями.
          for (var refcode in self.refcodes) {
            if ($.inArray(refcode, self.refsWithRecords) != -1) {
              refCode = refcode;
              break;
            }
          }
        }
        self.selectedRefCode = refCode;

        //Запоминаем последнее введенное значение, что бы не было зацикливания. Замечание №55804.
        self.lastQuery = query;
        self.suggest(afterShowCallback);
        self.hideSpinner();
      };

      function onSearchError() {
        //self.hideContainer();
        self.hideSpinner();
      };

      function searchInOtherReferences() {
        self.refsWithRecords = [];
        self.refsWithErrorMessage = {};
        var requests = [];
        for (var refcode in self.refcodes) {
          var OnSuccessFunc = (function (refcode) { //Эта обертка нужна что бы замыкание переменной refcode сработало корректно, иначе в refcode будет всегда последнее значение.
            return function (maxPages, data) {
              // Какие-то записи найдены.
              if (data.length > 0) {
                self.refsWithRecords.push(refcode);
              }
            }
          })(refcode);
          var OnErrorFunc = (function (refcode) {
            return function (msg, isHttp) {
              // Если там ошибка и она не тот что записей не найдено, сохраним её для вывода в шапке.
              if (msg !== self.NoMatchText) {
                // В некоторых случаях нужно отображать разные сообщения в заголовке и при раскрытии.
                self.refsWithErrorMessage[refcode] = msg.split('^')[0];
              }
            }
          })(refcode);
          // Добавляем запрос к списку, что бы дождаться выполнения всех.
          requests.push(self.sendQuery(refcode, query, 1, self.max, OnSuccessFunc, OnErrorFunc));
        }
        self.lastRequests = $.merge(self.lastRequests, requests);
        // Ждем пока все запросы выполнятся.
        deferred = $.when.apply(this, requests);
        deferred.done(onSearchQueryDoneCallback).fail(onSearchError);
      };

      // Прекращаем все предыдущие запросы.
      while (self.lastRequests.length > 0) {
        self.lastRequests.pop().abort();
      };

      // Если не нужно показывать всё, то при пустом значении input поиск не выполняем.
      if (self.multiselect && self.suggestLastMode != 'show_all' && self.inp.val() == '') {
        self.hideContainer();
        self.hideSpinner();
        return;
      }

      self.showSpinner();

      var query = (self.suggestLastMode == 'show_all' ? '' : self.getQueryValue());

      // Если текст запроса изменился, то сбрасываем страницы на первую.
      if (query != self.lastQuery || self.selectedRefCode != self.lastSelectedRefCode) {
        self.currentPage = 1;
        self.results.scrollTop(0);
      }

      // Если указаны несколько кодов справочника, то отображаем выбор.
      // Провериям изменился ли текст в input что бы переполучить refsWithRecords. Замечание №55804.
      if ((query != self.lastQuery || (typeof self.selectedRefCode === 'undefined' || self.selectedRefCode == null)) && self.refcodesCount > 0) {
        if (self.refcodesCount > 1) {
          self.refsWithRecords = [];
          self.refsWithErrorMessage = {};

          if (!!self.mainReferenceCode) {
            self.sendQuery(self.mainReferenceCode, query, 1, self.max, function (maxPages, data) {
              // Какие-то записи найдены.
              if (data.length > 0) {
                for (var refcode in self.refcodes) {
                  self.refsWithRecords.push(refcode);
                }
                onSearchQueryDoneCallback();
              } else {
                for (var refcode in self.refcodes) {
                  if (refcode !== self.mainReferenceCode) {
                    self.refsWithRecords.push(refcode);
                  }
                }
                searchInOtherReferences();
              }
            }, function (msg, isHttp) {
              // Если там ошибка и она не тот что записей не найдено, сохраним её для вывода в шапке.
              if (msg !== self.NoMatchText) {
                // В некоторых случаях нужно отображать разные сообщения в заголовке и при раскрытии.
                self.refsWithErrorMessage[self.mainReferenceCode] = msg.split('^')[0];
              }
            }).fail(onSearchError);

          } else {
            // Делаем запросы по всем справочникам, что бы лишний раз не заставлять пользователя его выбирать.
            searchInOtherReferences();
          }

          return;
        } else {
          self.selectedRefCode = self.getFirstRefCode();
        }
      }

      if (Core.isStatisticEnabled) {
        // Записываем статистику.
        WA.CR.statistics.write({
          page: WA.getLocation(),
          action: 'LikeQuery',
          area: 'ReferenceRequisite',
          target: self.inp.get(0)
        });
      };

      self.lastRequests.push(self.sendQuery(self.selectedRefCode, query, self.currentPage, self.max, function (maxPages, data) {
        //OnSuccess
        self.maxPages = maxPages;
        if (self.currentPage == 1) self.table.empty().removeData('refcode');

        // Обновим видимость табилицы с записями справочника.
        self.updateTableVisibility();
        var isEmpty = self.createRows(self.selectedRefCode, data, afterShowCallback);

        if (!isEmpty && (self.suggestLastMode == 'show' || self.suggestLastMode == 'show_all')) {
          self.showContainer();
          if (afterShowCallback) afterShowCallback();
        } else {
          self.hideContainer();
        }

        self.hideSpinner();
      }, function (msg, isHttp) {
        // OnError

        // Обновим видимость табилицы с записями справочника.
        self.updateTableVisibility();

        if (msg != 'abort') {
          self.showError(isHttp ? L('SERVER_ERROR_OCCURRED') : msg);
        }
        self.hideSpinner();
      }));

      self.lastQuery = query;
      self.lastSelectedRefCode = self.selectedRefCode;
    },

    sendQuery: function (RefCode, Query, Page, Limit, OnSuccess, OnError) {
      var self = this;

      if (!self.refcodes[RefCode]) {
        var d = $.Deferred();
        d.reject();
        return d;
      }

      var filter = "";
      if (self.refcodes[RefCode] && self.refcodes[RefCode]['Filter'] !== null) {
        filter = self.refcodes[RefCode]['Filter'];
      } else {
        filter = self.inp.data('filter');
      };

      // Нужно ли отключать спец. обработку справочника.
      if (self.refcodes[RefCode]) {
        var disablespecialprocessing = self.refcodes[RefCode]['DisableSpecialProcessing'];
      }

      var queryContext = self.queryContext;
      // Множественный выбор ссылается на несколько ревизитов, поэтому меняем контекст.
      if (self.referenceCodesAndReqNamesInDetailSection && self.referenceCodesAndReqNamesInDetailSection[RefCode]) {
        queryContext = JSON.parse(queryContext);
        queryContext.requisiteNumber = self.referenceCodesAndReqNamesInDetailSection[RefCode].number;
        queryContext = JSON.stringify(queryContext);
      }

      var url = self.url + '&RefCode=' + encodeURI(RefCode);
      var params = $.extend({
        q: Query || "",
        limit: Limit,
        page: Page,
        filter: filter,
        sort: self.inp.data('sort'),
        useadditional: self.useadditional ? "1" : "0",
        disablespecialprocessing: disablespecialprocessing ? "1" : "0",
        queryContext: queryContext,
      }, self.extraParams || {});

      return self.dataProvider.sendQuery(url, params, OnSuccess, OnError);
    },

    // Обновяет видимость табилицы с записями справочника.
    updateTableVisibility: function () {
      var self = this;
      if ((typeof self.refsWithRecords != 'undefined' && self.refsWithRecords.length == 0) || !self.selectedRefIsClosed) {
        self.table.show();
      } else {
        self.table.hide();
      }
      // Сохраним в таблице код справочника записи которого были выбраны.
      self.table.data('refcode', self.selectedRefCode);
    },

    showError: function (msg, afterShowCallback) {
      var self = this;
      self.makeTitleAndFooter(afterShowCallback);

      // В некоторых случаях нужно отображать немного другой текст ошибки, чем в заголовке справочника.
      if (msg.indexOf('^') != -1) {
        if (self.multiselect) {
          msg = msg.split('^')[1];
        } else {
          msg = msg.replace('^', '. ');
        }
      }


      if (self.inp.offset().top === 0) return; //не показываем ничего если инпута уже нет


      self.table.html('<tr class="rs_tr"><td class="rs_td error">' + msg + '</td></tr>');
      self.showContainer();
      if (afterShowCallback) afterShowCallback();
      self.hideSpinner();
    },

    // Формирует шапку и подножие.
    makeTitleAndFooter: function (afterShowCallback) {
      var self = this;

      if (self.refcodesCount > 1) {
        var beforeRefCodes = [];
        var afterRefCodes = [];
        var current = beforeRefCodes;

        // Определяем коды справочника до и после выбранного.
        for (var refcode in self.refcodes) {
          current.push(refcode);
          if (refcode == self.selectedRefCode) {
            current = afterRefCodes;
          }
        }

        var makeDivs = function (codes, container) {
          if (codes.length == 0) {
            container.empty();
          } else {
            var html = '';
            for (var i = 0; i < codes.length; i++) {
              if ((typeof self.refsWithRecords != 'undefined' && $.inArray(codes[i], self.refsWithRecords) != -1) ||
                  (typeof self.refsWithErrorMessage != 'undefined' && typeof self.refsWithErrorMessage[codes[i]] != 'undefined')) {

                var cssClass = '';
                if (codes[i] == self.selectedRefCode) cssClass = 'selected';
                if (self.selectedRefIsClosed) cssClass += ' closed';

                html += '<div class="rs_RefCaption ' + cssClass + '" data-refcode="' + codes[i] + '">';
                html +=
                  '<p class="rs_ico">' +
                  '  <svg class="refselect-input__expand-icon">' +
                  '    <use xlink:href="#expand" />' +
                  '  </svg>' +
                  '</p>';
                html += self.refcodes[codes[i]].Caption;

                if (typeof self.refsWithErrorMessage != 'undefined' && typeof self.refsWithErrorMessage[codes[i]] != 'undefined') {
                  html += ' (' + $.trim(self.refsWithErrorMessage[codes[i]].toLowerCase()) + ')';
                }

                html += '</div>';
              }
            }
            container.html(html).find('div')
              .bind('click.refselect', function () { self.selectReference(this, afterShowCallback); })
              .hover(
                function () { $(this).addClass('hover'); },
                function () { $(this).parent().children('.rs_RefCaption').removeClass('hover'); }
              );
          }
        }

        //Формируем заголовок
        makeDivs(beforeRefCodes, self.title);
        if (beforeRefCodes.length > 0) {
          self.title.show();
        } else {
          self.title.hide();
        }

        //Формируем подножие
        makeDivs(afterRefCodes, self.footer);
        if (afterRefCodes.length > 0) {
          self.footer.show();
        } else {
          self.footer.hide();
        }
      } else {
        self.title.hide();
        self.footer.hide();
      }
    },

    // Выбирает справочник и открывает/подгружает его записи.
    selectReference: function (refCaption, afterShowCallback) {
      var self = this;
      var $this = $(refCaption);
      if ($this.hasClass('selected')) {
        self.selectedRefIsClosed = !$this.hasClass('closed');
      } else {
        self.selectedRefIsClosed = false;
      }

      // Навешиваем/снимаем стиль закрыточки справочника.
      if (self.selectedRefIsClosed) {
        $this.addClass('closed');
      } else {
        $this.removeClass('closed');
      }

      self.inp.focus();
      self.selectedRefCode = $this.data('refcode');
      self.suggest(afterShowCallback);
    },

    // Генерирует data-атрибут и нужный css-класс для html-элемента.
    getHintData: function (refcode, id, text) {
      var self = this;
      // Нужно ли отображать подсказку.
      var hintClass = (self.refcodes[refcode] && self.refcodes[refcode].NeedShowHint ? "hint " : "");
      var hintData;
      if (self.refcodes[refcode] && self.refcodes[refcode].NeedShowHint) {
        if (id.indexOf('_') != -1) {
          var idParts = id.split('_');
          refcode = idParts[0];
          id = idParts[1];
        }
        hintData = ' data-hint="{ \'compcode\' : \'' + refcode + '\', \'id\' : \'' + id + '\' }" ';
      } else {
        hintData = ' title="' + (('' + text + '').replace(/"/g, '&quot;')) + '" ';
      }
      return {
        'attr': hintData,
        'class': hintClass
      };
    },

    // Строит результирующую таблицу.
    createRows: function (refCode, rows, afterShowCallback) {
      var self = this;
      var tr, td;
      var isEmpty;
      var table_html = '';

      self.makeTitleAndFooter(afterShowCallback);

      var rowsByUid = {};

      if (rows.length > 0) {
        rows.forEach(function (row, i) {
          if (isNaN(parseInt(row.id, 10)) || row.id >= 0) {
            var rowUid = '' + Math.random();
            rowsByUid[rowUid] = row;
            var hintData = self.getHintData(refCode, row.id, row.title);
            table_html += '<tr data-stataction="SelectReferenceRecordItem" class="' + hintData['class'] + (i % 2 == 0 ? "rs_tr_even" : "rs_tr_odd") + '" data-rowuid="' + rowUid + '" ' + hintData['attr'] + '>';
            table_html += '<td class="rs_td">' + self.highlight(row.encodedTitle, self.getQueryValue()) + '</td>';
          } else {
            table_html += '<tr class="rs_tr_error ' + (i % 2 == 0 ? "rs_tr_even" : "rs_tr_odd") + '">';
            table_html += '<td class="rs_td error"><div>' + row.encodedTitle + '</div></td>';
            // Только 1 сообщение об ошибке и пустая строка.
            if (rows.length == 0) {
              self.maxPages = self.currentPage;
            }
          }
          table_html += '</tr>';
        });

        //Удалем строку с ошибкой, если она там была.
        self.table.find('td.error').parent().remove();

        var newRows = $(table_html);
        // Связываем HTML строку с данными.
        $.each(newRows, function (index, newRow) {
          var rowUid = $(newRow).data('rowuid');
          $(newRow).data('rowData', rowsByUid[rowUid]);
        });

        var trs = self.table.append(newRows).find('tr:not(.rs_tr_error)');
        trs.unbind('mouseenter.refselect').bind('mouseenter.refselect', function () { $(this).siblings('.rs_tr_over').removeClass('rs_tr_over'); $(this).addClass('rs_tr_over'); })
           .unbind('mouseleave.refselect').bind('mouseleave.refselect', function () { $(this).parent().find('.rs_tr_over').removeClass('rs_tr_over'); })
           .unbind('click.refselect').bind('click.refselect', function () { self.select(false, $(this)); });
        isEmpty = false;
        if (self.refcodes[refCode] && self.refcodes[refCode].NeedShowHint) {
          trs.each(function () {
            InitAdditionalInfoTooltip($(this));
          });
        }

        self.inp.trigger('OnRowsCreated', [refCode, trs]);

      } else {
        if (self.currentPage == 1) {
          isEmpty = !self.showNoMatchText;
          self.selectEmpty(false);
          if (self.showNoMatchText) {
            self.table.html('<tr class="rs_tr"><td class="rs_td error">' + self.NoMatchText + '</td></tr>');
          }
        } else {
          // Изменим максимальное количество страниц, если записей уже нет.
          self.maxPages = self.currentPage;
        }
      }

      return isEmpty;
    },

    setCoordForContainer: function () {
      var self = this;
      var c = self.inpParent;
      if (c !== null && c.offset()) {
        var top = c.offset().top + c.height() + 3;
        var height = self.container.outerHeight();
        var wh = $(window).height();
        if ((top + height) > wh) {
          top = c.offset().top - height - 1;
          if (top < 0) top = 0;
        }

        var width = c.outerWidth(true) - 3;
        self.container.css({
          left: (c.offset().left),
          top: top,
          width: width,
          minWidth: Math.max(width, 360)
        });
      }
    },

    // Функция подцветки искомой строки.
    highlight: function (value, term) {
      if (term == '') return value;
      return value.replace(new RegExp("(?![^&;]+;)(?!<[^<>]*)(" + term.replace(/([\^\$\(\)\[\]\{\}\*\.\+\?\|\\])/gi, "\\$1") + ")(?![^<>]*>)(?![^&;]+;)", "gi"), "<strong>$1</strong>");
    },

    // Скрыть плейсхолдер
    _hidePlaceholder: function () {
      var self = this;
      $(function () {
        if (self.fakeInp)
          self.fakeInp.attr("placeholder", "");
      });
    },

    // Показать плейсхолдер
    _showPlaceholder: function () {
      var self = this;
      $(function () {
        if (self.fakeInp) {
          var input = self.fakeInp.parent().before().find('.input');
          var placeholder = input.data('placeholder') ? input.data('placeholder') : input.attr('placeholder');
          self.fakeInp.attr('placeholder', placeholder);
        }
      });
    }
  };

  $.fn.extend({
    ReferenceSelect: function (options, img) {
      this.data('ReferenceSelectInstance', new rs(this, options, img));
      this.trigger('Init');
      return this;
    },
    SetSelected: function (v) {
      this.trigger('SetSelected', [v]);
    },
    result: function (handler) {
      return this.bind("result", handler);
    },
    resultMulti: function (handler) {
      return this.bind("resultMulti", handler);
    },
    ReplaceSelectedItem: function (oldID, newValues) {
      this.trigger('ReplaceSelectedItem', [oldID, newValues, false]);
    },
    ReplaceLastSelectedItem: function (oldID, newValues) {
      this.trigger('ReplaceSelectedItem', [oldID, newValues, true]);
    },
    Clear: function () {
      this.trigger("Clear");
    },
    HideContainer: function () {
      this.trigger("HideContainer");
    },
    SetValue: function (val, needTriggerResult) {
      this.trigger("SetValue", [val, needTriggerResult]);
      return $(this);
    },
    SetValues: function (values, needTriggerResult) {
      this.trigger("SetValues", [values, needTriggerResult]);
      return $(this);
    },
    SetDisabled: function () {
      this.trigger("SetDisabled", [true]);
      return $(this);
    },
    SetEnabled: function () {
      this.trigger("SetDisabled", [false]);
      return $(this);
    }
  });
})(jQuery);
